module.exports = __webpack_public_path__ + "img/DK16917931.49629cb8.png";